import { render, staticRenderFns } from "./BooleanInputField.vue?vue&type=template&id=a5d1ec32&"
import script from "./BooleanInputField.vue?vue&type=script&lang=js&"
export * from "./BooleanInputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports